import { useQuery } from '@tanstack/react-query';
import useApiClient from '../../Shared/services/api';
import { getArtEvents } from '../../Shared/services/artEvent/artEventService';
import { ArtEventEndpointQueryKeys } from '../../Shared/constants/artEvent/endpoints';
import { GetArtEventsApiResponse } from '../../Shared/interfaces/artEvent/ArtEventInterfaces';
import { ApiError } from '../../Shared/interfaces/ApiError';

export const useGetArtEvents = () => {
  const api = useApiClient();

  return useQuery<GetArtEventsApiResponse, ApiError>({
    queryKey: [ArtEventEndpointQueryKeys.GET_ART_EVENTS],
    queryFn: () => getArtEvents(api),
  });
};
